import React, { useMemo } from "react";
import { iPhoneFrame } from "../../images";

const BEZEL_ORIGINAL_WIDTH = 1684;
const BEZEL_ORIGINAL_HEIGHT = 3178;
const scale = 0.25;
const BEZEL_WIDTH = BEZEL_ORIGINAL_WIDTH * scale;
const BEZEL_HEIGHT = BEZEL_ORIGINAL_HEIGHT * scale;
console.log("BEZEL WIDTH", BEZEL_WIDTH);

const IPhonePreview = ({ thumbnail, title, body }) => {
  const content = title + body;

  // Generate a thumbnail URL if it's a File object
  const thumbnailUrl = useMemo(() => {
    if (thumbnail instanceof File) {
      return URL.createObjectURL(thumbnail);
    }
    return thumbnail; // Assume it's already a valid URL
  }, [thumbnail]);

  return (
    <div
      className={`min-w-[${BEZEL_WIDTH}px] ml-4`}
      style={{ width: `${BEZEL_WIDTH}px`, height: `${BEZEL_HEIGHT}px` }}
    >
      <div className="relative">
        <div className="overflow-y-auto scrollbar-hidden rounded-[calc(100%/6)] absolute w-full h-full top-0 left-0 bg-white mt-2">
          {thumbnailUrl && (
            <img
              src={thumbnailUrl}
              alt="Thumbnail"
              height={200}
              className="bg-gray-100 w-full h-[30%] object-cover z-10"
            />
          )}
          <div
            dangerouslySetInnerHTML={{ __html: content }}
            className="px-8 top-0"
          />
        </div>
        <img
          src={iPhoneFrame}
          alt="iphone"
          className="relative pointer-events-none"
        />
      </div>
    </div>
  );
};

export default IPhonePreview;
